<template>
    <!-- NOTIFICATIONS -->
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
        <!--<feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="unreadNotifications.length" />-->
        <feather-icon icon="KeyIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="0" />
        <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

            <div class="notification-top text-center p-5 bg-primary text-white">
                <!--<h3 class="text-white">{{ unreadNotifications.length }} New</h3>-->
                <h3 class="text-white">Restricted Area</h3>
                <p class="opacity-75">Exclusively visible to users with 'Admin' role.</p>

            </div>


            <div class="vx-row mt-8 ml-2 mr-2">
                    <div class="vx-col lg:w-1/2 w-full">
                        <router-link :to="{ path: '/bankaccounts' }" class="text-inherit">
                            <vx-card title class="mb-base text-center cursor-pointer" id="page-user-view">
                                <svg v-html="imgSvgBank" width="80" height="80"></svg>
                                <h4 class="mb-2">Banks</h4>
                            </vx-card>
                        </router-link>
                    </div>
                    <div class="vx-col lg:w-1/2 w-full">
                        <router-link :to="{ path: '/kpi' }" class="text-inherit">
                            <vx-card title class="mb-base text-center cursor-pointer" id="page-user-view">
                                <svg v-html="imgSvgKpi" width="80" height="80"></svg>
                                <h4 class="mb-2">KPI</h4>
                            </vx-card>
                        </router-link>
                    </div>
                    <div class="vx-col lg:w-1/2 w-full">
                        <router-link :to="{ path: '/budget' }" class="text-inherit">
                            <vx-card title class="mb-base text-center cursor-pointer" id="page-user-view">
                                <svg v-html="imgSvgBudget" width="80" height="80"></svg>
                                <h4 class="mb-2">Budget</h4>
                            </vx-card>
                        </router-link>
                    </div>
                    <div class="vx-col lg:w-1/2 w-full">
                        <router-link :to="{ path: '/broker-check' }" class="text-inherit">
                            <vx-card title class="mb-base text-center cursor-pointer" id="page-user-view">
                                <svg v-html="imgSvgBrokerCheck" width="80" height="80"></svg>
                                <h4 class="mb-2">Broker</h4>
                            </vx-card>
                        </router-link>
                    </div>
                    <div class="vx-col lg:w-1/2 w-full">
                        <router-link :to="{ path: '/client-access' }" class="text-inherit">
                            <vx-card title class="mb-base text-center cursor-pointer" id="page-user-view">
                                <svg v-html="imgSvgClientAccess" width="80" height="80"></svg>
                                <h4 class="mb-2">Clients</h4>
                            </vx-card>
                        </router-link>
                    </div>
                    <div class="vx-col lg:w-1/2 w-full">
                        <router-link :to="{ path: '/solar-admin' }" class="text-inherit">
                            <vx-card title class="mb-base text-center cursor-pointer" id="page-user-view">
                                <svg v-html="imgSvgSolar" width="80" height="80"></svg>
                                <h4 class="mb-2">Solar Panel</h4>
                            </vx-card>
                        </router-link>
                    </div>
                    <div class="vx-col lg:w-1/2 w-full">
                        <router-link :to="{ path: '/agent' }" class="text-inherit">
                            <vx-card title class="mb-base text-center cursor-pointer" id="page-user-view">
                                <svg v-html="imgSvgAgent" width="80" height="80"></svg>
                                <h4 class="mb-2">AGENT</h4>
                            </vx-card>
                        </router-link>
                    </div>
                    <div class="vx-col lg:w-1/2 w-full">
                        <router-link :to="{ path: '/pricing-sso' }" class="text-inherit">
                            <vx-card title class="mb-base text-center cursor-pointer" id="page-user-view">
                                <svg v-html="imgSvgPricing" width="80" height="80"></svg>
                                <h4 class="mb-2">Pricing</h4>
                            </vx-card>
                        </router-link>
                    </div>
                    <div class="vx-col lg:w-1/2 w-full">
                        <router-link :to="{ path: '/accounting' }" class="text-inherit">
                            <vx-card title class="mb-base text-center cursor-pointer" id="page-user-view">
                                <svg v-html="imgSvgAccounting" width="80" height="80"></svg>
                                <h4 class="mb-2">Finance</h4>
                            </vx-card>
                        </router-link>
                    </div>
                </div>
                <div class="vx-row mt-0 ml-2 mr-2">
                </div>

        </vs-dropdown-menu>
    </vs-dropdown>
</template>
  
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      imgSvgBank: '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-building-bank" width="80" height="80" viewBox="0 0 24 24" stroke-width="0.8" stroke="#95bea6" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 21l18 0" /><path d="M3 10l18 0" /><path d="M5 6l7 -3l7 3" /><path d="M4 10l0 11" /><path d="M20 10l0 11" /><path d="M8 14l0 3" /><path d="M12 14l0 3" /><path d="M16 14l0 3" /></svg>',
      imgSvgKpi:'<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-database-dollar" width="80" height="80" viewBox="0 0 24 24" stroke-width="0.8" stroke="#95bea6" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3" /><path d="M4 6v6c0 1.657 3.582 3 8 3c.415 0 .822 -.012 1.22 -.035" /><path d="M20 10v-4" /><path d="M4 12v6c0 1.657 3.582 3 8 3c.352 0 .698 -.009 1.037 -.025" /><path d="M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" /><path d="M19 21v1m0 -8v1" /></svg>',
      imgSvgBudget:`<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#95bea6" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-calendar-dollar">
  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
  <path d="M13 21h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3" />
  <path d="M16 3v4" />
  <path d="M8 3v4" />
  <path d="M4 11h12.5" />
  <path d="M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" />
  <path d="M19 21v1m0 -8v1" />
</svg>`,
      // Client Access : logins du portail client (lecture seule).
      imgSvgClientAccess: '<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#95bea6" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" /><path d="M6 21v-2a4 4 0 0 1 4 -4h3" /><path d="M15 19l2 2l4 -4" /></svg>',
      imgSvgBrokerCheck: `<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#95bea6" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-circle-check">
  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
  <path d="M9 12l2 2l4 -4" />
</svg>`,
      imgSvgSolar: `<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#95bea6" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-solar-panel">
  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
  <path d="M12 3v2" />
  <path d="M5.6 5.6l1.4 1.4" />
  <path d="M18.4 5.6l-1.4 1.4" />
  <path d="M3 12h2" />
  <path d="M19 12h2" />
  <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
  <path d="M4 21l4 -7" />
  <path d="M20 21l-4 -7" />
  <path d="M8 14h8l1 7h-10z" />
</svg>`,
      imgSvgAgent: `<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#95bea6" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-cpu">
  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
  <path d="M5 5m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z" />
  <path d="M9 9h6v6h-6z" />
  <path d="M3 10h2" /><path d="M3 14h2" />
  <path d="M10 3v2" /><path d="M14 3v2" />
  <path d="M21 10h-2" /><path d="M21 14h-2" />
  <path d="M14 21v-2" /><path d="M10 21v-2" />
</svg>`,
      imgSvgPricing: `<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#95bea6" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-tag">
  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
  <path d="M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
  <path d="M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z" />
</svg>`,
      imgSvgAccounting: `<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#95bea6" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-report-money">
  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
  <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
  <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
  <path d="M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" />
  <path d="M12 17v1m0 -8v1" />
</svg>`

    }
  },
  computed: {

  },
  watch: {
  },
  methods: {
  },
  mounted () {
  },
  created () {

  }

}

</script>
  